import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Snackbar from "@material-ui/core/Snackbar";
import Fade from "@material-ui/core/Fade";
import { base_url } from "../../Api/Api";
import { Popup } from "../../Global/Popup";
import { Loader } from "../../Global/Loader";

import Header from "../../Global/Header";
import Answeritem from "./Answeritem";
import { Fragment } from "react";
import ShowAnsweritem from "./ShowAnsweritem";

const EndedExam = (props) => {
    const [data, setData] = useState([]);
    const [state, setState] = useState({
        selectedAnswer: null, // answer selected
        paramsId: 0, // params number
        defaultChecked: {
            answer_ids: [],
            question_id: "",
        }, // checked input
        popupStatus: false, // toggle popup
        animationItems: false,
        animParamsId: 0,
        finished: false,
        examIdMain: 0,
        pervQueId: 0,
    });

    const [details, setDetails] = useState({
        loaderMountloader: false,
        loaderMount: false,
        animCmpnt: false,
    });
 

    useEffect(() => {
        window.onpopstate = (e) => {
            // props.history.go(1);
        };

        setDetails({
            ...details,
            loaderMount: true,
        });

        base_url
            .get(`exam/${props.match.params.coursId}`,)
            .then((response) => {
                setState({
                    ...state,
                    // examIdMain: response.data.questions[0].pivot.exam_id,
                    paramsId: response.data.questions.length,
                });
                setDetails({
                    ...details,
                    animCmpnt: true,
                    loaderMount: false,
                });
                setData(response.data);
            })
            .catch((error) => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        localStorage.clear();
                        props.history.push(`/Entrance`);
                        window.location.reload();
                    }
                }
            });
    }, []);
 





    return (
        <div className={`instructpg exam ${details.animCmpnt ? "active" : ""}`}>
            <Header innerPage={true} title={"آزمون"} />

            <Loader active={details.loader} />

            <div className="bk-light">
                <Loader active={details.loaderMount} />
            </div>

          

            <Fragment>
                <div className="exams">
                    <div className="timer">
                        {/* <span>
                            {parseInt(props.match.params.id)}
                            {" از "}
                            {data.length == 0 ? "" : data.questions.length}
                        </span> */}
                        
                    </div>
                    <div className="step">
                        {/* <LinearProgress
                            variant="determinate"
                            value={
                                data.length
                                    ? (100 / data.questions.length) *
                                    parseInt(props.match.params.id)
                                    : null
                            }
                        /> */}
                    </div>
                    <div className={`exam-list ${state.animationItems ? "active" : ""}`}>
                        {data.questions?.map((qa) => (
                            <ShowAnsweritem
                                rightAnswer={qa.type === "DESCRIPTIVE" ? qa.descriptive_answer : qa.right_answers}
                                question={qa}
                                answer={state.answerCount}
                            />
                       ))}
                    </div>
                </div>
                <div className="btn-exam">
                    {/* <div className={`btn-base btn-black btn-sircle btn-brdr`}>
                        {parseInt(props.match.params.id) == 1 ? null : (
                            <Button variant="contained" onClick={() => prevQuestion()}>
                                قبلی
                            </Button>
                        )}
                    </div>
                    <div className={`btn-base btn-black btn-sircle`}>
                        <Button variant="contained" onClick={() => nextQuestion()}>
                            {parseInt(props.match.params.id) === data?.questions?.length
                                ? "پایان آزمون"
                                : "بعدی"}
                        </Button>
                    </div> */}
                </div>
            </Fragment>
        </div>
    );
};

export default EndedExam;
